import React, { useEffect, useState } from "react";
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';

import { get, downloadImage } from '../../utils/Api';
import StaticBox from '../../utils/StaticBox';

import Toolbar from '@mui/material/Toolbar';
import ReplayIcon from '@mui/icons-material/Replay';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import WarningIcon from '@mui/icons-material/Warning';
import PersonIcon from '@mui/icons-material/Person';
import PersonOffIcon from '@mui/icons-material/PersonOff';
import Chip from '@mui/material/Chip';

const FRONTEND_URL = process.env.REACT_APP_FRONTEND_URL;

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#1565c0',
    color: theme.palette.common.white,
  },
}));

const cssIconButton = {
  minWidth: '45px',
  width: '45px',
  height: '45px',
  borderRadius: '4px',
  padding: 0,
};

const defaultEmptyMessage = 'Não há registros de usuários!';

const COLORS = {
  status_success: {
    icon: () => CheckCircleIcon,
    iconStyle: { height: '22px', color: '#7fff00', },
    tableRow: { cursor: 'pointer', },
    typography: { whiteSpace: 'pre-wrap', wordBreak: 'break-word', fontWeight: 'bold', color: '#7fff00', display: 'inline-block', fontFamily: '"Courier New", Courier, monospace', },
  },
  status_error: {
    icon: () => ErrorIcon,
    iconStyle: { height: '22px', color: '#ff0000', },
    tableRow: { cursor: 'pointer', },
    typography: { whiteSpace: 'pre-wrap', wordBreak: 'break-word', fontWeight: 'bold', color: '#ff0000', display: 'inline-block', fontFamily: '"Courier New", Courier, monospace', },
  },

  ativo_logado: {
    icon: () => PersonIcon,
    iconStyle: { height: '22px', color: '#7fff00', },
    tableRow: { cursor: 'pointer', },
    typography: { whiteSpace: 'pre-wrap', wordBreak: 'break-word', fontWeight: 'bold', color: '#7fff00', display: 'inline-block', fontFamily: '"Courier New", Courier, monospace', },
  },
  ativo_deslogado: {
    icon: () => PersonOffIcon,
    iconStyle: { height: '22px', color: '#ffff00', },
    tableRow: { cursor: 'pointer', },
    typography: { whiteSpace: 'pre-wrap', wordBreak: 'break-word', fontWeight: 'bold', color: '#ffff00', display: 'inline-block', fontFamily: '"Courier New", Courier, monospace', },
  },
  inativo_logado: {
    icon: () => PersonOffIcon,
    iconStyle: { height: '22px', color: '#ffff00', },
    tableRow: { cursor: 'pointer', },
    typography: { whiteSpace: 'pre-wrap', wordBreak: 'break-word', fontWeight: 'bold', color: '#ffff00', display: 'inline-block', fontFamily: '"Courier New", Courier, monospace', },
  },
  inativo_deslogado: {
    icon: () => PersonOffIcon,
    iconStyle: { height: '22px', color: '#ff0000', },
    tableRow: { cursor: 'pointer', },
    typography: { whiteSpace: 'pre-wrap', wordBreak: 'break-word', fontWeight: 'bold', color: '#ff0000', display: 'inline-block', fontFamily: '"Courier New", Courier, monospace', },
  },

  desconhecido: {
    icon: () => WarningIcon,
    iconStyle: { height: '22px', color: '#ffffff', },
    tableRow: { cursor: 'pointer', },
    typography: { whiteSpace: 'pre-wrap', wordBreak: 'break-word', fontWeight: 'bold', color: '#ffffff', display: 'inline-block', fontFamily: '"Courier New", Courier, monospace', },
  },
};

function EnhancedTableHead() {
  return (
    <TableHead>
      <TableRow>
        <StyledTableCell
          key={'status_usuarios'}
          sx={{ borderBottomColor: '#0c0c0c', }}>
          <Typography>
            {'Status dos usuários'}
          </Typography>
        </StyledTableCell>
      </TableRow>
    </TableHead>
  );
}

export default function Logging({
  version,
  setLoading,
  handleMessage,
  setError,
  error,
}) {
  const [refresh,setRefresh] = useState(crypto.randomUUID());

  const [statusUsuarios, setStatusUsuarios] = useState([]);
  const [momentoConsulta,setMomentoConsulta] = useState('GET...');

  const recarregar = () => {
    setRefresh(crypto.randomUUID());
  };

  const toolbar = (momentoConsulta) => {
    return (
      <Toolbar
        position="static"
      >
        <Box
          sx={{
            flex: 2,
            display: 'flex',
            justifycontent: 'flex-start',
            alignItems: 'center',
            gap: 2,
          }}
        >
          <Typography
            variant="h6"
            id="tableTitle"
            component="div"
            sx={{
              marginRight: '10px',
            }}
          >
            {momentoConsulta}
          </Typography>
        </Box>

        <Box
          sx={{
            flex: 1,
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'right',
            gap: 2,
            ml: 'auto',
          }}
        >
          <Stack direction="row" spacing={1} justifycontent="flex-end">

            <Button
              sx={cssIconButton}
              variant="contained"
              size="large"
              color="success"
              onClick={recarregar}>
              <ReplayIcon />
            </Button>

          </Stack>
        </Box>

      </Toolbar>
    );
  };

  useEffect(()=>{
    const getStatus = () => {
      if (error) { return; }
      setLoading(true);

      get(`api/usuarios/logados`,(json,message,severity)=>{

        if (json.success) {

          const url_test_backend = `api/status-backend`;
          const startBackend = performance.now();
          get(url_test_backend,(jsonBackend,messageBackend,severityBackend)=>{

              if (jsonBackend.status) {

                const endBackend = performance.now();
                const msBackend = (endBackend - startBackend);
                let servidor_gunicorn = json.servidor_gunicorn;
                servidor_gunicorn.registro_status = "status_success";
                servidor_gunicorn.registro_refresh = `${msBackend.toFixed(2)}ms`;

                const file_name_test_frontend = 'logo512.png';
                const url_test_frontend = `${FRONTEND_URL}/img/${file_name_test_frontend}`;
                const startFrontend = performance.now();
                downloadImage(url_test_frontend,file_name_test_frontend,(jsonFrontend,messageFrontend,severityFrontend)=>{
                  if (jsonFrontend.download) {

                    let servidor_nginx = json.servidor_nginx;
                    servidor_nginx.registro_status = "status_success";
                    const endFrontend = performance.now();
                    const msFrontend = (endFrontend - startFrontend);
                    servidor_nginx.registro_refresh = `${msFrontend.toFixed(2)}ms`;

                    let servidor_mysql = json.servidor_mysql;

                    let lista = [...json.registros];
                    lista.unshift(json.data_consulta);
                    lista.unshift(json.total_logados);
                    lista.unshift(servidor_gunicorn);
                    lista.unshift(servidor_nginx);
                    lista.unshift(servidor_mysql);

                    setStatusUsuarios(lista);
                    setMomentoConsulta(json.momento_consulta);

                    setLoading(false);

                  } else {
                    handleMessage(messageFrontend,severityFrontend,'',true);
                    setLoading(false);
                  }
                },(error,message,severity)=>{
                  handleMessage(message,severity,error,true);
                  setLoading(false);
                });

              } else {
                handleMessage(messageBackend,severityBackend,'',true);
                setLoading(false);
              }

          });

        } else {
          handleMessage(message,severity,'',true);
          setLoading(false);
        }

      },(error,message,severity)=>{
        handleMessage(message,severity,error,true);
        setLoading(false);
      });
    };

    getStatus();
  },[refresh]);

  return (
    <StaticBox
      version={version}
      setLoading={setLoading}
      handleMessage={handleMessage}
      error={error}
      setError={setError}>
      <React.Fragment>
        {toolbar(momentoConsulta)}
        <TableContainer component={Paper} sx={{ height: '96%' }}>
          <Table
            sx={{ minWidth: { xs: 0, sm: 750 } }}
            aria-labelledby="tableTitle"
            size={'medium'}
          >
            <EnhancedTableHead />
            <TableBody sx={{ backgroundColor: '#0c0c0c', }}>
              {
                (statusUsuarios.length === 0) ? (
                  <TableRow>
                    <TableCell
                      align="center"
                      sx={{
                        borderBottomColor: '#0c0c0c',
                      }}>
                      {defaultEmptyMessage}
                    </TableCell>
                  </TableRow>
                ) : (
                  statusUsuarios.map((row, index) => {
                    const labelId = `enhanced-table-checkbox-${index}`;
                    const IconComponent = COLORS[row.registro_status].icon();

                    return (
                      <TableRow
                        role="checkbox"
                        tabIndex={-1}
                        key={`${row.registro_identificacao}-${index}`}
                        sx={COLORS[row.registro_status].tableRow}>
                        <TableCell
                          component="th"
                          id={labelId}
                          scope="row"
                          sx={{
                            padding: { xs: '16px', sm: '6px 6px 6px 16px' },
                            borderBottomColor: '#0c0c0c',
                          }}>
                          <Stack direction="row" spacing={1}>
                            <IconComponent sx={COLORS[row.registro_status].iconStyle} />
                            <Typography component="span" sx={COLORS[row.registro_status].typography}>
                              {row.registro_identificacao}
                            </Typography>
                            {
                              (row.registro_exibir_refresh) ? (
                                <Chip
                                  label={row.registro_refresh}
                                  color='branco'
                                  sx={{
                                    display: 'block',
                                    height: '24px',
                                    '& .MuiChip-label': {
                                      lineHeight: '22px',
                                    },
                                  }}
                                />
                              ) : (<></>)
                            }
                          </Stack>
                        </TableCell>
                      </TableRow>
                    );
                  })
                )
              }

            </TableBody>
          </Table>
        </TableContainer>
      </React.Fragment>
    </StaticBox >
  );
}
